import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6bdb8c2e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6bdb8c2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb8c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdb8c2e')) {
      api.createRecord('6bdb8c2e', component.options)
    } else {
      api.reload('6bdb8c2e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6bdb8c2e&scoped=true", function () {
      api.rerender('6bdb8c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditInfo/portalAdministrativePenalties/detail.vue"
export default component.exports